module.exports = __webpack_public_path__ + "img/pic1.d17c28b3.jpg";